<template>
  <div id="components-layout-demo-basic">
    <a-layout>
      <a-layout-header>
        <div class="wrapper">
          <mobile-default-header :productName="detailData.productName"
            >Header</mobile-default-header
          >
        </div>
      </a-layout-header>
      <a-layout-content>
        <div class="card-container">
          <div class="production-detail">产品详情</div>
          <div class="production-list">
            <a-list
              item-layout="horizontal"
              :data-source="detailData.latestNews"
              :grid="{ column: 1 }"
              size="large"
              :loading="loading"
            >
              <template #loadMore>
                <div class="load-more-text-align">
                  <a-spin v-if="loadingMore" />
                  <a-button
                    v-else
                    type="link"
                    class="production-list-font"
                    @click="loadedMore"
                    >加载更多>></a-button
                  >
                </div>
              </template>
              <template #renderItem="{ item }">
                <a-list-item style="margin-top: 5vh">
                  <a-list-item-meta>
                    <template #avatar>
                      <p class="production-list-date-font">
                        {{ dayjs(item.disclosureDate).format("YYYY-MM-DD") }}
                      </p>
                      <p class="production-list-disclosure-font">披露日期</p>
                    </template>
                    <template #title>
                      <div class="production-list-title">
                        <div class="production-list-divide-line"></div>
                        <a
                          :href="item.fileURL"
                          :title="item.fileName"
                          class="production-list-font"
                        >
                          {{ item.fileName }}
                        </a>
                      </div>
                    </template>
                  </a-list-item-meta>
                </a-list-item>
              </template>
            </a-list>
          </div>
        </div>
      </a-layout-content>
      <div class="footer-header"></div>
      <a-layout-footer>
        <mobile-default-footer></mobile-default-footer>
      </a-layout-footer>
    </a-layout>
  </div>
</template>
<script setup>
import { reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import dayjs from "dayjs";
import MobileDefaultFooter from "@/components/Footer/mobile-default-footer.vue";
import MobileDefaultHeader from "@/components/Header/mobile-default-header.vue";
import { storageFn } from "@/utils";

const loading = ref(false);
const loadingMore = ref(false);
const loadMore = ref(false);

const route = useRoute();
const router = useRouter();
const state = reactive({
  fileId: route.params?.fileId,
  // fileId: route.params?.fileId == ":fileId" ? "ZJSJY" : route.params?.fileId,
});

const detailData = reactive({
  productName: null,
  latestNews: [],
  latestNewsloaded: [],
});

const getDetailPageData = () => {
  const res = storageFn.getSession(state.fileId);
  if (!res) {
    router.push(`/product/${state.fileId}`);
    return;
  }
  detailData.productName = res.productName;
  window.localStorage.setItem("pageTitle", detailData.productName);
  // store.commit('title/setProjectName', detailData.productName);
  detailData.latestNewsloaded = res.fileList;
  detailData.latestNews = detailData.latestNewsloaded.slice(0, 8);
};

const loadedMore = () => {
  detailData.latestNews = detailData.latestNewsloaded;
  loadingMore.value = true;
};

getDetailPageData();
</script>
<style>
#app {
  height: 100%;
}
</style>
<style lang="scss" scoped>
#components-layout-demo-basic {
  height: auto;
}

.wrapper {
  box-sizing: border-box;
  min-height: 100%;
}

.ant-layout-header {
  height: auto;
  width: 100%;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  line-height: 4rem;
  background: #001529;
}

.footer-header {
  width: 100%;
  height: 4px;
  background: linear-gradient(135deg, #910e0e 0%, #b68f54 100%) #910e0e;
}

.ant-layout-footer {
  bottom: 0;
  width: 100%;
  height: auto;
  color: rgba(0, 0, 0, 0.65);
  box-shadow: inset 0 0.3125rem /* 5/16 */ 0.3125rem
    linear-gradient(135deg, #910e0e 0%, #b68f54 100%) #910e0e;
  font-size: 0.875rem /* 14/16 */;
  background: #ffffff;
}

.card-container {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;

  .production-detail {
    padding: 40px 0 0 4%;
    font-size: 28px;
    font-weight: 600;
    color: rgba(57, 59, 65, 0.84);
  }

  .production-list {
    width: 98%;
    // height: 810px; //变动
    margin: 0px auto;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 2px 9px 0px rgba(235, 185, 178, 0.11);
    border-radius: 10px;
    overflow: auto;

    .load-more-text-align {
      text-align: center;
      margin: 30px 0 40px;
      height: 32px;
      line-height: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
    }

    .production-list-title {
      display: flex;
    }

    .production-list-divide-line {
      width: 1px;
      height: 80px;
      margin: auto 15px;
      border: 1px solid #eeeeee;
    }

    .production-list-font {
      font-size: 28px;
      color: #333333;
      line-height: 40px;
      font-family: PingFangSC-Regular, PingFang SC;
    }

    .production-list-date-font {
      font-size: 30px;
      font-family: D-DIN, D;
      font-weight: normal;
      color: #910e0e;
      line-height: 35px;
      padding-top: 2%;
    }

    .production-list-disclosure-font {
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 33px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }
}
</style>
